import * as actions from 'actions';

export default (state = false, action) =>
  (action.type === actions.PAGE_READY ? true : state);



// WEBPACK FOOTER //
// ./src/reducers/pageReady.js